import { Close } from '@mui/icons-material';
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';

import { LocalModal, ModalContentContainer } from '@/components';
import { Link } from '@/containers';
import { CPEDetails } from '@/types';

export const CPEDetailsModal = ({
  isOpened,
  setOpened,
  CPEDetails,
}: {
  isOpened: boolean;
  setOpened: (isOpened: boolean) => void;
  CPEDetails: CPEDetails;
}) => {
  return (
    <LocalModal
      open={isOpened}
      onClose={() => setOpened(false)}
      name="CPE_QAS_REQUIREMENTS">
      <ModalContentContainer stretch>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
            <Typography variant="h1">CPE / QAS Requirements</Typography>
            <IconButton
              onClick={() => setOpened(false)}
              aria-label="Close modal">
              <Close />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              gap: 2,
              alignItems: 'start',
            }}>
            <Box>
              <Typography>
                <strong>Publication Date:</strong>
                <br />
                {CPEDetails.publishDate &&
                  format(CPEDetails.publishDate, 'MMMM d, yyyy')}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body3SemiBold">Expiration Date:</Typography>
              <Typography>
                1 year from start of the course or upon subscription expiry
              </Typography>
            </Box>
            <Box>
              <Typography variant="body3SemiBold">CPE Credits:</Typography>
              <Typography>{CPEDetails.credits}</Typography>
            </Box>
            <Box>
              <Typography variant="body3SemiBold">
                Instructional Delivery Method:
              </Typography>
              <Typography>QAS Self Study</Typography>
            </Box>
            <Box>
              <Typography variant="body3SemiBold">Program Level:</Typography>
              <Typography>{CPEDetails.programLevel}</Typography>
            </Box>
            <Box>
              <Typography variant="body3SemiBold">
                Course Registration:
              </Typography>
              <Typography>LumiQ subscription and account required</Typography>
            </Box>
            <Box sx={{ gridColumn: '1 / -1' }}>
              <Divider />
            </Box>
            <Box>
              <Typography variant="body3SemiBold">Field of Study:</Typography>
              <Typography>{CPEDetails.fieldOfStudy}</Typography>
            </Box>
            <Box>
              <Typography variant="body3SemiBold">Prerequisites:</Typography>
              {arrayToList(CPEDetails.prerequisites)}
            </Box>
            <Box>
              <Typography variant="body3SemiBold">
                Advanced Preparations:
              </Typography>
              {arrayToList(CPEDetails.advancedPreparations)}
            </Box>
          </Box>
        </Box>
      </ModalContentContainer>
    </LocalModal>
  );
};

const arrayToList = (array: { name: string; url?: string }[]) => {
  return array?.length > 0 ? (
    <List sx={{ listStyleType: 'disc', pl: 2 }}>
      {array.map((element, i) => (
        <ListItem key={i} sx={{ display: 'list-item' }}>
          {element.url ? (
            <Link to={element.url}>{element.name}</Link>
          ) : (
            <Typography>{element.name}</Typography>
          )}
        </ListItem>
      ))}
    </List>
  ) : (
    <Typography>None</Typography>
  );
};
